import React from 'react';
import { Link } from 'react-router-dom';

const Privacy = () => {
  return (
    <div>
      {/* Hero */}
      <section style={{
        background: `linear-gradient(135deg, rgba(212, 196, 176, 0.15) 0%, rgba(250, 249, 247, 1) 100%)`,
        padding: 'var(--space-xxxl) var(--space-l)',
        textAlign: 'center'
      }}>
        <div className="container">
          <h1 style={{ marginBottom: 'var(--space-m)' }}>
            Политика обработки персональных данных
          </h1>
          <p style={{
            color: 'var(--warm-gray)',
            fontSize: '0.9375rem'
          }}>
            Последнее обновление: {new Date().toLocaleDateString('ru-RU')}
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="section">
        <div className="container">
          <div style={{
            maxWidth: '800px',
            margin: '0 auto'
          }}>
            <div style={{
              backgroundColor: 'var(--soft-gray)',
              padding: 'var(--space-xl)',
              borderRadius: 'var(--radius-md)',
              marginBottom: 'var(--space-xxl)'
            }}>
              <p style={{
                color: 'var(--charcoal)',
                fontSize: '1.0625rem',
                lineHeight: '1.7'
              }}>
                Настоящая Политика конфиденциальности персональных данных действует в отношении всех данных, которые сайт и/или его функциональные сервисы могут получить о пользователе во время использования им сайта.
              </p>
            </div>

            <div style={{ marginBottom: 'var(--space-xxl)' }}>
              <h2 style={{ marginBottom: 'var(--space-l)' }}>
                1. Определения
              </h2>
              <p style={{
                color: 'var(--warm-gray)',
                fontSize: '1.0625rem',
                lineHeight: '1.7',
                marginBottom: 'var(--space-l)'
              }}>
                1.1. Сайт – интернет-сайт, расположенный в сети интернет по адресу, содержащий информацию об услугах консультанта по стилю Натальи Ромашовой.
              </p>
              <p style={{
                color: 'var(--warm-gray)',
                fontSize: '1.0625rem',
                lineHeight: '1.7',
                marginBottom: 'var(--space-l)'
              }}>
                1.2. Пользователь – физическое лицо, осуществляющее доступ к Сайту посредством сети Интернет.
              </p>
              <p style={{
                color: 'var(--warm-gray)',
                fontSize: '1.0625rem',
                lineHeight: '1.7'
              }}>
                1.3. Персональные данные – любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных).
              </p>
            </div>

            <div style={{ marginBottom: 'var(--space-xxl)' }}>
              <h2 style={{ marginBottom: 'var(--space-l)' }}>
                2. Какие данные мы собираем
              </h2>
              <p style={{
                color: 'var(--warm-gray)',
                fontSize: '1.0625rem',
                lineHeight: '1.7',
                marginBottom: 'var(--space-l)'
              }}>
                При заполнении формы заявки на сайте мы собираем следующую информацию:
              </p>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0
              }}>
                {[
                  'Имя',
                  'Город проживания',
                  'Контактные данные (ник в Telegram)',
                  'Предпочитаемый способ связи',
                  'Интересующие услуги'
                ].map((item, index) => (
                  <li key={index} style={{
                    color: 'var(--warm-gray)',
                    marginBottom: 'var(--space-m)',
                    paddingLeft: 'var(--space-l)',
                    position: 'relative',
                    fontSize: '1.0625rem'
                  }}>
                    <span style={{
                      position: 'absolute',
                      left: 0,
                      color: 'var(--warm-sage)'
                    }}>•</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div style={{ marginBottom: 'var(--space-xxl)' }}>
              <h2 style={{ marginBottom: 'var(--space-l)' }}>
                3. Цели использования данных
              </h2>
              <p style={{
                color: 'var(--warm-gray)',
                fontSize: '1.0625rem',
                lineHeight: '1.7',
                marginBottom: 'var(--space-l)'
              }}>
                Мы используем ваши персональные данные исключительно для:
              </p>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0
              }}>
                {[
                  'Связи с вами для обсуждения услуг',
                  'Назначения встреч и консультаций',
                  'Предоставления информации об услугах',
                  'Улучшения качества обслуживания'
                ].map((item, index) => (
                  <li key={index} style={{
                    color: 'var(--warm-gray)',
                    marginBottom: 'var(--space-m)',
                    paddingLeft: 'var(--space-l)',
                    position: 'relative',
                    fontSize: '1.0625rem'
                  }}>
                    <span style={{
                      position: 'absolute',
                      left: 0,
                      color: 'var(--warm-sage)'
                    }}>•</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div style={{ marginBottom: 'var(--space-xxl)' }}>
              <h2 style={{ marginBottom: 'var(--space-l)' }}>
                4. Защита данных
              </h2>
              <p style={{
                color: 'var(--warm-gray)',
                fontSize: '1.0625rem',
                lineHeight: '1.7'
              }}>
                Мы применяем необходимые организационные и технические меры для защиты персональных данных пользователя от неправомерного или случайного доступа, уничтожения, изменения, блокирования, копирования, распространения, а также от иных неправомерных действий с ней третьих лиц.
              </p>
            </div>

            <div style={{ marginBottom: 'var(--space-xxl)' }}>
              <h2 style={{ marginBottom: 'var(--space-l)' }}>
                5. Передача данных третьим лицам
              </h2>
              <p style={{
                color: 'var(--warm-gray)',
                fontSize: '1.0625rem',
                lineHeight: '1.7'
              }}>
                Мы не передаем ваши персональные данные третьим лицам без вашего явного согласия, за исключением случаев, предусмотренных законодательством Российской Федерации.
              </p>
            </div>

            <div style={{ marginBottom: 'var(--space-xxl)' }}>
              <h2 style={{ marginBottom: 'var(--space-l)' }}>
                6. Ваши права
              </h2>
              <p style={{
                color: 'var(--warm-gray)',
                fontSize: '1.0625rem',
                lineHeight: '1.7',
                marginBottom: 'var(--space-l)'
              }}>
                Вы имеете право:
              </p>
              <ul style={{
                listStyle: 'none',
                padding: 0,
                margin: 0
              }}>
                {[
                  'Получать информацию о хранении и использовании ваших данных',
                  'Требовать изменения или удаления ваших данных',
                  'Отозвать согласие на обработку персональных данных',
                  'Обжаловать действия или бездействие в уполномоченный орган по защите прав субъектов персональных данных'
                ].map((item, index) => (
                  <li key={index} style={{
                    color: 'var(--warm-gray)',
                    marginBottom: 'var(--space-m)',
                    paddingLeft: 'var(--space-l)',
                    position: 'relative',
                    fontSize: '1.0625rem'
                  }}>
                    <span style={{
                      position: 'absolute',
                      left: 0,
                      color: 'var(--warm-sage)'
                    }}>•</span>
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div style={{ marginBottom: 'var(--space-xxl)' }}>
              <h2 style={{ marginBottom: 'var(--space-l)' }}>
                7. Срок хранения данных
              </h2>
              <p style={{
                color: 'var(--warm-gray)',
                fontSize: '1.0625rem',
                lineHeight: '1.7'
              }}>
                Персональные данные хранятся в течение срока, необходимого для достижения целей их обработки, если иной срок не предусмотрен договором или законодательством.
              </p>
            </div>

            <div style={{
              padding: 'var(--space-xl)',
              backgroundColor: 'var(--soft-gray)',
              borderRadius: 'var(--radius-md)'
            }}>
              <h3 style={{ marginBottom: 'var(--space-l)' }}>
                Контакты
              </h3>
              <p style={{
                color: 'var(--warm-gray)',
                fontSize: '1.0625rem',
                lineHeight: '1.7',
                marginBottom: 'var(--space-l)'
              }}>
                По всем вопросам, связанным с обработкой персональных данных, вы можете связаться с нами через форму обратной связи на сайте или в мессенджерах.
              </p>
              <Link to="/#contact">
                <button className="btn-primary">
                  Связаться
                </button>
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
